import { HeaderBar } from "../../generic/components/header-bar";
import { HeaderBarTitle } from "../../generic/components/header-bar-title";

import type { ErrorProps } from "../../../utils/errors/extract-zod-tree-error-props";
import type { MomentStatus } from "../../moment-card/types";
import type { FC, ReactNode } from "react";

export const FollowUpHeader: FC<{
  loading: boolean;
  programTitle?: string;
  title: string;
  setTitle: (title: string) => void;
  status: MomentStatus;
  error: ErrorProps;
  disabled: boolean;
  children?: ReactNode;
}> = ({ loading, programTitle, title, setTitle, status, error, disabled, children }) => (
  <HeaderBar navBurger>
    <HeaderBarTitle
      title={{
        type: "editable",
        value: title,
        onChange: setTitle,
        error,
      }}
      subtitle={programTitle}
      status={status}
      loading={loading}
      disabled={disabled}
    />
    {children}
  </HeaderBar>
);
